<template>
  <form>
    <div
      v-if="isBtoC"
      class="form-wrap">
      <div
        v-for="(choice, index) in selectedChoices"
        :key="index"
        class="form-group form-group-confirm">
        <div>
          <div class="form-label">
            <label class="control-label">
              {{ choice.question }}
            </label>
          </div>
          <div class="form-item">
            <span class="form-item-confirm-text">
              {{ choice.answer }}
            </span>
          </div>
        </div>
      </div>
      <div
        v-for="(pattern,index) in inputPatterns"
        :key="pattern.id"
        class="form-group form-group-confirm">
        <div
          v-if="pattern.type === 'string' || pattern.type === 'text'
            || pattern.type === 'problem_store_name' || pattern.type === 'url'
            || pattern.type === 'select_browser' || pattern.type === 'select_pc'
            || pattern.type === 'phone_number' || pattern.type === 'email'">
          <div class="form-label">
            <label
              class="control-label">
              {{ pattern.custom_label || '' }}
            </label>
          </div>
          <div class="form-item">
            <span class="form-item-confirm-text">
              {{ inputs[pattern.id] }}
            </span>
          </div>
        </div>
        <div
          v-else-if="pattern.type === 'store_checkbox'">
          <div class="form-label">
            <label
              class="control-label">
              {{ pattern.custom_label || '問題が発生している配信ストア' }}
            </label>
          </div>
          <div class="form-item">
            <span class="form-item-confirm-text">
              {{ getActiveStores(inputs[pattern.id]).join(',') }}
            </span>
          </div>
        </div>
        <div
          v-else-if="pattern.type === 'release_id'">
          <div class="form-label">
            <label
              class="control-label">
              {{ pattern.custom_label || '問題のタイトルID' }}
            </label>
          </div>
          <div class="form-item">
            <span class="form-item-confirm-text">
              {{ inputs[pattern.id].release_id }}
            </span>
          </div>
        </div>
        <div
          v-else-if="pattern.type === 'release_ids'">
          <div class="form-label">
            <label
              class="control-label">
              {{ pattern.custom_label || '問題のタイトルID' }}
            </label>
          </div>
          <div class="form-item">
            <span class="form-item-confirm-text">
              {{ inputs[pattern.id].map(v => v.value)
                .filter(v => v !== '').join(',') }}
            </span>
          </div>
        </div>
        <div
          v-else-if="pattern.type === 'tracks'">
          <div class="form-label">
            <label
              class="control-label">
              {{ pattern.custom_label || '問題の楽曲' }}
            </label>
          </div>
          <div class="form-item">
            <span class="form-item-confirm-text">
              {{ inputs[pattern.id].filter(v => v.value !== '')
                .map(v => v.value+'('+v.text+')').join(',') }}
            </span>
          </div>
        </div>
        <div
          v-else-if="pattern.type === 'default'">
          <div
            class="form-label"
            style="padding-bottom:10px;">
            <label
              class="control-label">
              お名前
            </label>
          </div>
          <div
            class="form-item"
            style="padding-bottom:10px;">
            <span class="form-item-confirm-text">
              {{ inputs[pattern.id].name }}
            </span>
          </div>
          <div
            class="form-label"
            style="padding-bottom:10px;">
            <label
              class="control-label">
              お客様のメールアドレス（ご連絡先）
            </label>
          </div>
          <div
            class="form-item"
            style="padding-bottom:10px;">
            <span class="form-item-confirm-text">
              {{ inputs[pattern.id].email }}
            </span>
          </div>
          <div
            class="form-label"
            style="padding-bottom:10px;">
            <label
              class="control-label">
              件名
            </label>
          </div>
          <div
            class="form-item"
            style="padding-bottom:10px;">
            <span class="form-item-confirm-text">
              {{ inputs[pattern.id].subject }}
            </span>
          </div>
          <div
            class="form-label"
            style="padding-bottom:10px;">
            <label
              class="control-label">
              お問い合わせ(内容の詳細)
            </label>
          </div>
          <div
            class="form-item"
            style="padding-bottom:10px;">
            <span class="form-item-confirm-text">
              {{ inputs[pattern.id].body }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="form-group form-group-confirm">
        <div>
          <div class="form-label">
            <label
              class="control-label">
              添付ファイル
            </label>
          </div>
          <div class="form-item">
            <img
              v-if="image"
              style="max-width: 320px"
              :src="image">
            <span
              v-else
              class="form-item-confirm-text">
              なし
            </span>
          </div>
        </div>
      </div>
      <div class="c-btn-wrap">
        <a
          class="c-btn"
          @click.prevent="onSendClicked">
          送信する
          <span class="c-btn__icon-arrow">
          </span>
        </a>
        <a
          class="c-btn c-btn--back c-btn--back-left"
          @click.prevent="onChangeClicked">
          変更する
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left">
          </span>
        </a>
      </div>
    </div>

    <div
      v-else
      class="form-wrap">
      <div class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            お名前
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.name }}
          </span>
        </div>
      </div>
      <div class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            お客様のメールアドレス
            <br class="pc">
            （ご連絡先）
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.email }}
          </span>
        </div>
      </div>
      <div class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            お問い合わせ内容
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.type }}
          </span>
        </div>
      </div>
      <div
        v-if="form.type!=='配信停止について' && form.type!=='キャンペーン応募'"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            件名
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.subject }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type==='配信停止について' || form.type==='キャンペーン応募'"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label"
            for="release_title">
            <span v-if="form.type==='キャンペーン応募'">応募するリリースタイトル</span>
            <span v-else>対象リリースタイトル</span>
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.release_title }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type==='配信停止について' || form.type==='キャンペーン応募'"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label"
            for="artist_name">
            <span v-if="form.type==='キャンペーン応募'">応募する対象アーティスト名</span>
            <span v-else>対象アーティスト名</span>
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.artist_name }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type==='配信停止について' && isBtoC"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            リリースID
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.release_id }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type==='配信停止について' && isBtoB"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            対象JANコード
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.jan }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type!=='キャンペーン応募'"
        class="form-group form-group--last form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            <span v-if="form.type==='配信停止について'">配信停止理由</span>
            <span v-else>お問い合わせ（内容の詳細）</span>
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text indent-contact-body">
            {{ form.body }}
          </span>
        </div>
      </div>
      <div
        v-if="form.type!=='キャンペーン応募'"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            添付ファイル
          </label>
        </div>
        <div class="form-item">
          <img
            v-if="image"
            style="max-width: 320px"
            :src="image">
        </div>
      </div>
    </div>
    <div
      v-if="!isBtoC"
      class="c-btn-wrap">
      <a
        class="c-btn"
        @click.prevent="onSendClicked">
        送信する
        <span class="c-btn__icon-arrow">
        </span>
      </a>
      <a
        class="c-btn c-btn--back c-btn--back-left"
        @click.prevent="onChangeClicked">
        変更する
        <span class="c-btn__icon-arrow c-btn__icon-arrow--left">
        </span>
      </a>
    </div>
  </form>
</template>

<script>
export default {
  name: 'ContactConfirm',
  props: {
    form: {
      type: Object,
      required: true,
    },
    inputs: {
      type: Object,
      required: true,
    },
    inputPatterns: {
      type: Array,
      required: true,
    },
    image: {
      type: String,
      require: false,
      default: null,
    },
    selectedChoices: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onChangeClicked() {
      this.$emit('change-clicked')
    },
    onSendClicked() {
      this.$emit('send-clicked')
    },
    getActiveStores(stores) {
      const ary = []
      Object.keys(stores).forEach(store => {
        if (stores[store]) {
          ary.push(store)
        }
      })
      return ary
    },
  },
}
</script>

<style scoped>
.indent-contact-body {
  white-space: pre-line;
  word-break: break-all;
}

.control-label {
  font-size:120%;
}
</style>
